import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { HotelResultCardProps } from '../types/bot.types';
import { AiFillStar } from 'react-icons/ai';
import { Button } from 'antd';
import { IoBed } from 'react-icons/io5';
import { formatBotPrice } from './formatBotPrice';

const HotelResultCard: React.FC<HotelResultCardProps> = ({
  name, stars, destination, checkIn, checkOut, nights,
  mealPlan, pricePerNight, totalPrice, currency, freeCancellation, rating, imageUrl, onSelect,
}) => {
  const t = useSelector((s: RootState) => (s.config.translations as any)?.bot);

  return (
    <div className="bot-result-card bot-result-card--hotel">
      <div className="bot-result-card__image-wrap">
        {imageUrl
          ? <img src={imageUrl} alt={name} className="bot-result-card__image" />
          : <div className="bot-result-card__image-placeholder"><IoBed size={32} /></div>}
      </div>
      <div className="bot-result-card__body">
        <div className="bot-result-card__name">{name}</div>
        <div className="bot-result-card__stars">
          {Array.from({ length: Math.min(stars, 5) }).map((_, i) => <AiFillStar key={i} color="#f5a623" />)}
        </div>
        {destination && <div className="bot-result-card__destination bot-result-card__meta">📍 {destination}</div>}
        <div className="bot-result-card__dates">📅 {checkIn} → {checkOut} · {nights}{t?.result?.nights ? ` ${t.result.nights}` : 'n'}</div>
        {mealPlan && <span className="bot-result-card__badge">{mealPlan}</span>}
        {freeCancellation && <span className="bot-result-card__badge bot-result-card__badge--green">{t?.result?.freeCancellation ?? 'Free cancellation'}</span>}
        {rating != null && <span className="bot-result-card__rating">{rating}/10</span>}
      </div>
      <div className="bot-result-card__footer">
        <div>
          {pricePerNight !== undefined && (
            <div className="bot-result-card__per-night">{currency} {pricePerNight}{t?.result?.perNight ?? '/night'}</div>
          )}
          <div className="bot-result-card__price">{currency} {formatBotPrice(totalPrice)}</div>
        </div>
        <Button size="small" type="primary" className="btn-style-5" onClick={onSelect}>
          {t?.result?.select ?? 'Select'}
        </Button>
      </div>
    </div>
  );
};

export default HotelResultCard;
